import { createSlice } from '@reduxjs/toolkit';
import { resetALL } from '../../../../../.globals/redux/actions';
import moment from 'moment';

const INIT_STATE = {
    loading: false,
    error: null,
    filters: {
        globals: {
            rangeDate: {
                start: moment.utc().subtract(7, 'days').startOf('day').toDate(),
                end: moment.utc().subtract(1, 'days').endOf('day').toDate()
            },
            timeFrame: 'last7days',
            tags: [],
            events: [],
            drivers: [],
            tagHierarchyRootId: null,
            tagLevel: null,
        },
        // Specific filters for each gadget
    },
    sorts: []
};

const driverPerformanceDashboardRedux = createSlice({
    name: "driverPerformance/dashboard",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        driverPerformanceDashboardUpdateFilters(state, action) {
            // Create a completely new object to avoid prototype issues
            const newFilters = JSON.parse(JSON.stringify(action.payload));

            // Clean up empty gadget filters
            Object.keys(newFilters).forEach(key => {
                if (key !== 'globals' && newFilters[key] &&
                    typeof newFilters[key] === 'object' &&
                    Object.keys(newFilters[key]).length === 0) {
                    delete newFilters[key];
                }
            });

            // Return a completely new state object
            return {
                ...state,
                filters: newFilters
            };
        },
        driverPerformanceDashboardUpdatSorts(state, action) {
            // Return a completely new state object
            return {
                ...state,
                sorts: action.payload
            };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);
    }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceDashboardRedux;

// Extract and export each action creator by name
export const { reset, driverPerformanceDashboardUpdateFilters, driverPerformanceDashboardUpdatSorts } = actions;

// Export the reducer, either as a default or named export
export default reducer;
